import React, { LabelHTMLAttributes } from "react";

interface Props extends LabelHTMLAttributes<HTMLLabelElement> {
  label?: string;
  name?: string;
  required?: boolean;
}

export default function CommonLabel({
  label,
  name,
  required,
  ...props
}: Props) {
  return (
    <label
      htmlFor={name}
      {...props}
      className="mb-1 text-sm font-medium text-brand-label-text"
    >
      {label}
      {required && <span className="text-red-500">*</span>}
    </label>
  );
}
